import { useWallet } from '@/hooks/useWallet';

interface HeaderProps {
  wallet: ReturnType<typeof useWallet>;
}

export function Header({ wallet }: HeaderProps) {
  return (
    <header className="fixed top-0 left-0 right-0 z-50 px-4 sm:px-8 py-3 sm:py-4 border-b border-border-subtle bg-panel-glass backdrop-blur-xl backdrop-saturate-[180%]">
      <div className="max-w-[1400px] mx-auto flex items-center justify-between">
        {/* Logo */}
        <a href="#" className="font-display text-xl sm:text-2xl font-bold tracking-tight text-white">
          ternoa<span className="text-accent">.</span>
        </a>

        {/* Nav */}
        <nav className="hidden md:flex items-center gap-8">
          {[
            { label: 'Balances', href: '#balances' },
            { label: 'Rewards', href: '#rewards' },
            { label: 'CIFERs', href: '#cifers' },
            { label: 'Social', href: '#social' },
            { label: 'Activity', href: '#activity' },
          ].map((item, i) => (
            <a
              key={item.label}
              href={item.href}
              className={`font-display text-sm font-medium uppercase tracking-widest transition-colors ${
                i === 0 ? 'text-accent' : 'text-gray-400 hover:text-white'
              }`}
            >
              {item.label}
            </a>
          ))}
        </nav>

        {/* Legacy */}
        <a
          href="#legacy"
          className="hidden md:inline-flex items-center gap-1.5 font-display text-[10px] font-bold uppercase tracking-[0.1em] px-3 py-1.5 rounded-ternoa border border-amber-500/20 bg-amber-500/10 text-amber-400 hover:bg-amber-500/20 transition-colors"
        >
          Legacy
        </a>

        {/* Wallet */}
        {wallet.address ? (
          <button
            onClick={wallet.disconnect}
            className="flex items-center gap-1.5 sm:gap-2.5 h-9 sm:h-11 px-3 sm:px-5 rounded-ternoa border border-glass-border bg-glass-bg backdrop-blur-xl font-display text-xs sm:text-sm font-medium text-gray-300 hover:border-accent hover:text-white transition-all cursor-pointer"
          >
            <span className="w-2 h-2 rounded-full bg-success animate-pulse-glow" />
            <span className="font-body text-sm tracking-wide">{wallet.shortAddress}</span>
            <ChevronDown />
          </button>
        ) : (
          <button onClick={wallet.connect} className="btn-primary btn-sm" disabled={wallet.isConnecting}>
            {wallet.isConnecting ? 'Connecting...' : 'Connect Wallet'}
          </button>
        )}
      </div>
    </header>
  );
}

function ChevronDown() {
  return (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M6 9l6 6 6-6" />
    </svg>
  );
}
